import React from 'react';
import { Chip } from 'src/shared/design-system/Chip';
import { FirstNonEmptyChild } from 'src/shared/design-system/FirstNonEmptyChild';

interface IProps {
  isPopular?: boolean;
  className?: string;
}

export const DishTags: React.FC<IProps> = ({ isPopular, className }) => (
  <div className={className}>
    <FirstNonEmptyChild>{isPopular && <Chip text='POPULAR' />}</FirstNonEmptyChild>
  </div>
);
